import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

// VatPeriodDetails — soft-retired in session 2j (row 60 Phase B cutover).
//
// The full implementation was orphaned: the only UI navigation to this
// route was `history.push(/${companyId}/vat-period/${periodId})` in
// VatReportingPeriods.js, and that handler was commented out. The legacy
// `handlePayment` inside this page also called POST /:companyId/templates/
// <hardcoded UUID>/suggestion against the retired template controller.
//
// The retired body is preserved in git history (see `git log -p`). The
// export is now a stub redirecting to the canonical period URL, mounted on
// both retired paths (`vat-period/:id` and the implementation-named
// `vat-period-stepper/:id`) so old bookmarks still resolve.
function VatPeriodDetails() {
    const { companyId, vatPeriodId } = useParams();
    const history = useHistory();
    useEffect(() => {
        // Best-effort redirect — anyone hitting a bookmarked
        // /vat-period/:id URL lands on the live stepper instead of an
        // empty page. Per-tenant URLs are stable across the migration
        // because both routes use the same {companyId, vatPeriodId}.
        if (companyId && vatPeriodId) {
            history.replace(`/${companyId}/vat-periods/${vatPeriodId}`);
        }
    }, [companyId, vatPeriodId, history]);
    return null;
}

// eslint-disable-next-line no-unused-vars
function _retired_VatPeriodDetails_body() {
    // Retired body removed in session 2j Phase B. The full implementation
    // (~530 lines, with the legacy /:companyId/templates/<UUID>/suggestion
    // call) is preserved in git history; recover via `git log -- this file`
    // if a forgotten consumer surfaces. Stub component above redirects to
    // the live VatPeriodStepper.
    return null;
}
export default VatPeriodDetails;
